import React, { useEffect, useState } from "react";
import { Tab, Tabs, Accordion, Card, AccordionContext } from "react-bootstrap";
import Table from "../table/table";
import icons from "../../assets/icons/icons";
import { isIterableArray } from "../../helpers/utils";
import color from "../../assets/colors";

const CustomToggle = ({ eventKey }: any) => {
  const currentEventKey = React.useContext(AccordionContext);
  const isCurrentEventKey = currentEventKey === eventKey;
  if (isCurrentEventKey) {
    return icons.negetive(color.$black, "m-r-10 ");
  } else {
    return icons.plus(color.$black, "m-r-10");
  }
};

const ProductSpecificationWidget = (props: any) => {
  const windowSize = useWindowSize();
  function useWindowSize() {
    const [dimension, setDimensions] = useState({
      height: undefined,
      width: undefined,
    });
    useEffect(() => {
      function handleResize() {
        setDimensions({
          height: window.innerHeight,
          width: window.innerWidth,
        });
      }

      window.addEventListener("resize", handleResize);
      handleResize();
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);
    return dimension;
  }
  if (props.n3Bundles) {
    return (
      <Accordion defaultActiveKey="1">
        {isIterableArray(props.data) &&
          props.data.map((item: any, i: string) => {
            return (
              <Card key={i}>
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey={`${i + 1}`}
                  className="according-header"
                >
                  <CustomToggle eventKey={`${i + 1}`} />
                  {item.label}
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={`${i + 1}`}>
                  {item.label === "DETAILS" ? (
                    <div className="details-header">
                    {
                      item.Values?.map((data, key) => (
                        <div key={key}>{data.Value}</div>
                      ))
                    }
                    </div>
                  ) : (
                    <div className="according-body">
                      <Table data={item.Values} note={item.note} />
                    </div>
                  )}
                </Accordion.Collapse>
              </Card>
            );
          })}
      </Accordion>
    );
  } else {
    if (windowSize.width >= 990) {
      return (
        props.data && (
          <div className="scroll-bar">
            <Tabs>
              {isIterableArray(props.data) &&
                props.data.map((item: any, i: number) => {
                  return (
                    item && (
                      <Tab key={i} eventKey={item.label} title={item.label}>
                        <Table data={item.Values} note={item.note} />
                      </Tab>
                    )
                  );
                })}
            </Tabs>
          </div>
        )
      );
    } else {
      return (
        <Accordion>
          {isIterableArray(props.data) &&
            props.data.map((item: any, i: string) => {
              return (
                <Card key={i}>
                  <Accordion.Toggle
                    as={Card.Header}
                    eventKey={i + 1}
                    className="according-header"
                  >
                    <CustomToggle eventKey={i + 1} />
                    {item.label}
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey={i + 1}>
                    <div className="according-body">
                      <Table data={item.Values} note={item.note} />
                    </div>
                  </Accordion.Collapse>
                </Card>
              );
            })}
        </Accordion>
      );
    }
  }
};

export default ProductSpecificationWidget;
